import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {ativarCupom, inativarCupom} from '../../actions/cupom/cuponsActions';
import moment from 'moment';
import {showSuccessMsg} from '../../util/messagesUtil'

const ModalConfirmacaoInativacaoCupom = ({inativar}) => (
    <div className="modal fade" id="ModalConfirmacaoInativacaoCupom" tabIndex="-1" role="dialog"
         aria-labelledby="ModalConfirmacaoInativacaoCupom" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Confirmar inativação do cupom? </p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal" onClick={() => {}}>Cancelar
                    </button>
                    <button type="button" className="btn btn-azul float-left" data-dismiss="modal"
                            onClick={() => inativar()}>Inativar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class Preco extends React.Component {
    selecionarCupom(cupom) {        
        this.props.selecionarCupom(cupom)

        this.props.changeFieldValue('formularioCadastroCupom',
            'id', cupom.id);
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataInicio', moment(cupom.dataInicio).toDate());
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataFim', moment(cupom.dataFim)
                .toDate());
        this.props.changeFieldValue('formularioCadastroCupom',
            'horaInicio', cupom.horaInicio);
        this.props.changeFieldValue('formularioCadastroCupom',
            'horaFim', cupom.horaFim);
        this.props.changeFieldValue('formularioCadastroCupom',
            'tipo', {label: cupom.descricaoTipo, value: cupom.chaveTipo});
        this.props.changeFieldValue('formularioCadastroCupom',
            'identificacao', cupom.identificacao);
        this.props.changeFieldValue('formularioCadastroCupom',
            'quantidade', cupom.quantidade);
        this.props.changeFieldValue('formularioCadastroCupom',
            'email', cupom.email);
        this.props.changeFieldValue('formularioCadastroCupom',
            'porcentagem', cupom.porcentagem);        
        this.props.changeFieldValue('formularioCadastroCupom',
            'plataforma', {label: cupom.descricaoPlataforma, value: cupom.chavePlataforma});

        if (cupom.origemRequisicao != null) {
            this.props.changeFieldValue('formularioCadastroCupom',
                'origemRequisicao',  {label: cupom.origemRequisicao.valor, value: cupom.origemRequisicao.chave} );
        }else{
            this.props.changeFieldValue('formularioCadastroCupom',
                'origemRequisicao',  {value: null, label: 'Todos'});
        }
    }

    exibirInativacao() {
        if (this.props.cupom.ativo) {
            return <input data-toggle="modal"
                          id={this.props.cupom.id}
                          data-target="#ModalConfirmacaoInativacaoCupom"
                          className="checkbox-custom"
                          type="checkbox"
                          checked={this.props.cupom.ativo}
                          defaultChecked={this.props.cupom.ativo}
                          onClick={() => this.props.selecionarCupom(this.props.cupom)}/>
        }
        return <input className="checkbox-custom"
                      type="checkbox"
                      id={this.props.cupom.id}
                      checked={this.props.cupom.ativo}
                      defaultChecked={this.props.cupom.ativo}
                      onClick={() => this.ativar()}/>
    }

    ativar() {
        this.props.ativarCupom(this.props.cupom.id).then(() => {
            showSuccessMsg('Cupom ativado com sucesso!');
            this.props.buscarCupons();
        })
    }

    inativar() {
        this.props.inativarCupom(this.props.cupomSelecionado.id).then(() => {
            showSuccessMsg('Cupom inativado com sucesso!');
            this.props.buscarCupons();
        });
    }

    exibirStatus () {
        if (this.props.cupom.ativo) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    exibirDetalhe() {
        return <div className="card-body" style={{backgroundColor: '#FFF'}}>
            <div className="row mb-2">
                <div className="col-md-6">
                    <strong>Período de
                        validade:</strong> {moment(this.props.cupom.dataInicio).format('DD/MM/YYYY')} {this.props.cupom.horaInicio} à {moment(this.props.cupom.dataFim).format('DD/MM/YYYY')} {this.props.cupom.horaFim}
                </div>
                <div className="col-md-6">
                    <strong>Porcentagem(%):</strong> {this.props.cupom.porcentagem}
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-md-6">
                    <strong>E-mail:</strong> {this.props.cupom.email ? this.props.cupom.email : 'Não informado'}
                </div>
                <div className="col-md-3">
                    <strong>Quantidade:</strong> {this.props.cupom.quantidade}
                </div>
                <div className="col-md-3">
                    <strong>Quantidade utilizada:</strong> {this.props.cupom.quantidadeUtilizada}
                </div>
            </div>
        </div>
    }


    render() {
        const {cupom} = this.props
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col">
                            <span className="titulo-mobile">Data de criação:&nbsp;</span>
                            {cupom.dataCriacao}
                        </div>

                        <div className="col">
                            <span className="titulo-mobile">Válido:&nbsp;</span>
                            {cupom.seValido ? 'Sim' : 'Não'}
                        </div>

                        <div className="col">
                            <span className="titulo-mobile">Identificação:&nbsp;</span>{cupom.identificacao}
                        </div>

                        <div className="col">
                            <span className="titulo-mobile">Tipo cupom :&nbsp;</span>{cupom.descricaoTipo}
                        </div>
                        <div className="col">
                            <span className="titulo-mobile">Platafomra :&nbsp;</span>{cupom.descricaoPlataforma}
                        </div>
                        <div className="col">
                            <div className="acoes">
                                <div className="botoes">
                                    <button type="button" className="btn btn-excluir"
                                            data-toggle="modal" key={cupom.id}
                                            data-target="#modalConfirmacaoExclusaoCupom"
                                            onClick={() => this.props.selecionarCupom(cupom)}>
                                        <i className="material-icons nav-icon">&#xe872;</i>
                                    </button>
                                    <button type="button" className="btn btn-editar ml-2"
                                            data-toggle="modal"
                                            data-target="#modalCadastrarCupom"
                                            onClick={() => this.selecionarCupom(cupom)}>
                                        <i className="material-icons nav-icon">&#xe150;</i>
                                    </button>
                                </div>
                                <div className="botoes">
                                            <span className="titulo-mobile tm-status">Status:&nbsp;</span>
                                                <div className="custom-btn-status ativo">
                                                    {this.exibirInativacao()}
                                                    <label htmlFor={cupom.id}
                                                    className="checkbox-custom-label"/>
                                                    {this.exibirStatus()}
                                                </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    {this.exibirDetalhe()}
                    <ModalConfirmacaoInativacaoCupom inativar={this.inativar.bind(this)}/>
                </div>

            </div>
        )
    }
}

export function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps, {
    changeFieldValue,
    ativarCupom,
    inativarCupom
})(reduxForm({
    form: 'formularioCadastroCupom'
})(Preco))
